<template>
    <div class="card">
        <div class="bg-blue-light p-1">
            <TitleButton
                :title="title"
                @onClickCloseButton="navigateToListPage"
            />
        </div>

      <div class="table-responsive m-2">
        <table class="table table-bordered">
          <thead>
          <tr>
            <th class="text-center">Department</th>
            <th class="text-center">No. of Vacancies</th>
            <th class="text-center">Job Location</th>
            <th class="text-center">Employment Type</th>
            <th class="text-center">Publish Date</th>
            <th class="text-center">Deadline</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td class="text-center">{{ jobInfo.department_name }}</td>
            <td class="text-center">{{ jobInfo.no_of_vacancy }}</td>
            <td class="text-center">{{ jobInfo.area_name }}</td>
            <td class="text-center">{{ jobInfo.employee_category_name }}</td>
            <td class="text-center">{{ jobInfo.publish_date_format }}</td>
            <td class="text-center">{{ jobInfo.application_deadline_format }}</td>
          </tr>
          </tbody>
        </table>
      </div>

      <div class="row text-center m-2">
        <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6">
          <div @click="goApplicantStatus('all')"
               :class="[
                  'rounded-3 applicant-card py-1 d-flex flex-column align-items-center justify-content-center h-100 border border-light-subtle cursor-pointer',
                  activeApplicantStatus === 'all' ? 'applicant-card-active' : ''
                ]">
            <div class="fs-3 fw-bolder text-black">
              {{ applicationStatus.shortlisted + applicationStatus.applied + applicationStatus.rejected + applicationStatus.final_selected}}
            </div>
            <div class="text-black fw-bolder">Applicants</div>
          </div>
        </div>
        <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6">
          <div @click="goApplicantStatus('shortlisted')"
               :class="[
                  'rounded-3 shortlisted-card py-1 d-flex flex-column align-items-center justify-content-center h-100 border border-light-subtle cursor-pointer',
                  activeApplicantStatus === 'shortlisted' ? 'shortlisted-card-active' : ''
                ]">
            <div class="fs-3 fw-bolder text-black">{{ applicationStatus.shortlisted }}</div>
            <div class="fw-bolder text-black">Shortlisted</div>
          </div>
        </div>
        <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6">
          <div
              @click="goApplicantStatus('rejected')"
              :class="[
                  'rounded-3 rejected-card py-1 d-flex flex-column align-items-center justify-content-center h-100 border border-light-subtle cursor-pointer',
                  activeApplicantStatus === 'rejected' ? 'rejected-card-active' : ''
                ]">
            <div class="fs-3 fw-bolder text-black">{{ applicationStatus.rejected }}</div>
            <div class="text-black fw-bolder">Rejected</div>
          </div>
        </div>
        <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6">
          <div
              @click="goApplicantStatus('final_selected')"
              :class="[
                  'rounded-3 final-selection-card py-1 d-flex flex-column align-items-center justify-content-center h-100 border border-light-subtle cursor-pointer',
                  activeApplicantStatus === 'final_selected' ? 'final-selection-card-active' : ''
                ]">
            <div class="fs-3 fw-bolder text-black">{{ applicationStatus.final_selected }}</div>
            <div class="fw-bolder text-black">Final Selection</div>
          </div>
        </div>
        </div>

      <div class="row text-center m-2">
        <div
            @click="goSelectionStatus(item.id)"
            class="col-xl-2 col-lg-3 col-md-4 col-sm-6 cursor-pointer"
            v-for="(item, index) in selectionStatus"
            :key="index"
        >
          <div
              :class="[
                  'rounded-3 bg-light py-1 d-flex flex-column align-items-center justify-content-center h-100 border border-light-subtle selection-status-card',
                  activeSelectionStatus === item.id ? 'selection-status-card-active' : ''
                ]"
          >
            <div class="fs-3 fw-bolder text-primary">{{ item.count }}</div>
            <div class="text-black fw-bolder">{{ item.name }}</div>
          </div>
        </div>
      </div>

      <div class="mb-4">
        <div class="candidate-list">
          <div class="m-2" v-for="(candidate, index) in tableItems" :key="index">
            <div class="card border-1 shadow-sm">
              <div class="card-body">
                <div class="row g-3">
                  <div class="col-md-2">
                    <div class="d-flex flex-column align-items-center h-100">
                      <div class="profile-photo-container mb-3">
                        <img
                            :src="candidate.photo"
                            :alt="candidate.name + ' profile photo'"
                            class="profile-photo rounded-circle border"
                        />
                      </div>

                      <div class="action-links text-center small">
                        <div class="mb-2">
                          <a v-if="candidate.attachments"  @click="viewAttachments(candidate.attachments)" class="text-info text-decoration-none d-block mb-1">
                            <i class="fas fa-download me-1"></i>Download CV
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-7">
                    <div class="row h-100">
                      <div class="col-4">
                        <div class="info-block">
                          <h6 class="fw-bold mb-2 text-dark">{{ candidate.name }}</h6>
                          <div class="small">
                            <p class="mb-1"><strong>Location:</strong> {{ candidate.area }}</p>
                            <p class="mb-1"><strong>Mobile no:</strong> <span class="text-success">{{ candidate.phone }}</span></p>
                            <p class="mb-1"><strong>Email:</strong> {{ candidate.email }}</p>
                            <p class="mb-1"><strong>Age:</strong> {{ candidate.age }}</p>
                            <p class="mb-1"><strong>Expected Salary:</strong> {{ candidate.expected_salary }}</p>
                            <p class="mb-0"><strong>Current Salary:</strong> {{ candidate.current_salary }}</p>
                          </div>
                        </div>
                      </div>

                      <div class="col-4">
                        <div class="info-block">
                          <div v-for="(experience, e) in candidate.experiences" :key="e" class="education-section mb-2">
                            <h6 class="fw-bold text-dark mb-1">{{ experience.experience }}</h6>
                            <p class="small mb-1">{{ experience.industry }}, {{ experience.location }}</p>
                          </div>
                        </div>
                      </div>

                      <div class="col-4">
                        <div class="info-block">
                          <div v-for="(education, e) in candidate.educations" :key="e" class="education-section mb-2">
                            <h6 class="fw-bold text-dark mb-1">{{ education.education }}</h6>
                            <p class="small mb-1">{{ education.institute_location }}</p>
                          </div>

                          <div class="skills-section">
                            <div class="skills-box bg-light p-2 rounded">
                              <h6 class="small fw-bold mb-1 text-center">Skill & Expertise</h6>
                              <div class="skills-content small" :key="e" v-for="(skill, e) in candidate.skills">
                                {{ skill.skill }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="d-flex flex-column h-100">
                      <div class="action-buttons mb-3">
                        <button
                            v-if="['shortlisted', 'final_selected'].includes(candidate.application_status)"
                            class="btn btn-success btn-sm me-2 px-1"
                            @click="jobApplicationStatusUpdate(candidate, 'final_selected')"
                            :disabled="candidate.application_status === 'final_selected'"
                        >
                          <i class="fas fa-check me-1"></i>Final Selection
                        </button>

                        <button
                            v-if="['applied', 'shortlisted'].includes(candidate.application_status)"
                            class="btn btn-success btn-sm me-2 px-1"
                            @click="jobApplicationStatusUpdate(candidate, 'shortlisted')"
                            :disabled="candidate.application_status === 'shortlisted'"
                        >
                          <i class="fas fa-check me-1"></i>Shortlist
                        </button>

                        <button
                            v-if="['applied', 'rejected'].includes(candidate.application_status)"
                            class="btn btn-danger btn-sm px-1"
                            @click="jobApplicationStatusUpdate(candidate, 'rejected')"
                            :disabled="candidate.application_status === 'rejected'"
                        >
                          <i class="fas fa-times me-1"></i>Reject
                        </button>
                      </div>

                      <div class="status-section flex-grow-1">
                        <div class="small">
                          <p v-for="(item, index) in selectionStatus"
                             :key="index"
                             @click="item.id !== candidate.selection_status_id && selectionStatusUpdate(item, candidate)"
                             :class="[
                              'mb-1 p-1 text-black fw-bolder bg-light rounded cursor-pointer',
                                  item.id === candidate.selection_status_id ? 'status-section-active' : ''
                              ]"
                          >
                            <strong> {{ item.name }}</strong>
                          </p>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="px-2 position-absolute bottom-0 mt-4">
        <Pagination :offset="params.offset" @onPageChange="onPageChange" ref="pagination"/>
      </div>
      <Loader v-if="loading"/>

      <ViewAttachment
          ref="viewAttachmentRef"
          :attachments="modalAttachments"
      />

      <SelectionStatusModal
          :selectionItem="selectionItem"
          :jobApplication="jobApplication"
          v-if="store.state.isModalOpenThree"
          @jobList="getJobList"
      />
    </div>

</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import { inject, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Loader from '@/components/atom/LoaderComponent'
import Pagination from '@/components/atom/Pagination'
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import { computed } from 'vue';
import ViewAttachment from '@/views/page/company/ngo/voucher/payment/ViewAttachmentModal.vue'
import SelectionStatusModal from '@/views/page/company/hr-payroll/job-application-manager/SelectionStatusModal.vue'

const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false)
const activeApplicantStatus = ref('applied')
const activeSelectionStatus = ref(null)
const modalAttachments = ref([]);
const viewAttachmentRef = ref();
const params = ref({
    offset: 10,
});
const title = ref("Designation (Hiring For)")
const token = computed(() => localStorage.getItem('token'));

const {
  fetchJobApplicationManage,
  updateJobApplicationStatus
} = handleHrPayroll()

const selectionItem = ref({})
const jobApplication = ref({})
const applicationStatus = ref({});
const selectionStatus = ref([]);
const jobInfo = ref({});
const tableItems = ref([]);

const jobApplicationStatusUpdate = (candidate, applicationStatus) => {
  const confirmed = confirm(`Are you sure you want to update ${candidate.name}'s application status to "${applicationStatus}"?`);
  if (!confirmed) return;

  loading.value = true;
  let query = `?company_id=${route.params.companyId}`;
  let applicationStatusData = {}
  applicationStatusData.job_application_id = candidate.id;
  applicationStatusData.application_status = applicationStatus;

  updateJobApplicationStatus(applicationStatusData, query)
      .then(res => {
        if (!res.status) {
          showError(res.message)
          return
        }
        showSuccess(res.message)
        getJobList()
      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
    loading.value = false
  })
};

const selectionStatusUpdate = (item, candidate) => {
  selectionItem.value = item;
  jobApplication.value = candidate;
  store.state.isModalOpenThree = true;
}

const setPaginationData = (data) => {
    store.commit('setPaginationData', data)
};

const setPagination = (data) => {
    setPaginationData({
        records: data.total,
        perPage: data.per_page,
        currentPage: data.current_page,
    })
}

const onPageChange = async (page) => {
    let routeQuery = Object.assign({}, route.query)
    routeQuery.page = page
    await router.push({path: route.path, query: routeQuery})
    await getJobList(activeApplicantStatus.value, activeSelectionStatus.value);
}

const goApplicantStatus = (applicantStatus)  => {
  activeApplicantStatus.value = applicantStatus;
  activeSelectionStatus.value = null;
  getJobList(applicantStatus, '')
}

const goSelectionStatus = (selectionStatus)  => {
  activeSelectionStatus.value = selectionStatus;
  activeApplicantStatus.value = null;
  getJobList('', selectionStatus)
}

const getJobList = async (applicantStatus = '', selectionStatusValue = '') => {
    let query = getQuery();
    if (applicantStatus) query+= '&application_status='+applicantStatus
    if (selectionStatusValue) query+= '&selection_status='+selectionStatusValue
    loading.value = true
    let jobId = route.query.jobId
    jobInfo.value = {}
    tableItems.value = []
    await fetchJobApplicationManage(jobId, query).then(res => {
        if (!res.status){
            showError(res.message)
            return
        }
        jobInfo.value = res.data.data;
        applicationStatus.value = res.data.applicationStatus;
        selectionStatus.value =  res.data.selectionStatus;
        title.value = res.data.data.title + ' (Hiring For)'
        tableItems.value = res.data.applications.data
        setPagination(res.data.applications)
    }).catch(err => {
        console.log(err)
    }).finally(() => {
        loading.value = false
    })
}

const getQuery = () => {
    let query = `?company_id=${route.params.companyId}`;
    if (route.query.page) query += '&page=' + route.query.page;
    if (route.query.start) query += '&start_date=' + route.query.start;
    if (route.query.end) query += '&end_date=' + route.query.end;
    query += '&offset=' + params.value.offset;
    return query;
}

const viewAttachments = (attachments) => {
  modalAttachments.value = [];
  modalAttachments.value = attachments;
  viewAttachmentRef.value && viewAttachmentRef.value.toggleModal();
}

function navigateToListPage() {
  delete route.query.jobId;
  router.push({name: 'job-posting', params: route.params, query: route.query});
}

onMounted(() => {
    Promise.all([
       getJobList(),
    ])
})
</script>

<style scoped>
.card-body p {
  margin-bottom: 6px;
}
.profile-photo {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border: 2px solid #dee2e6;
}
.profile-photo-container {
  position: relative;
}
.action-links a {
  font-size: 0.85rem;
  transition: color 0.2s ease;
}
.action-links a:hover {
  text-decoration: underline !important;
}
.info-block {
  height: 100%;
}
.skills-box {
  border: 1px solid #e9ecef;
  min-height: 80px;
}
.skills-content {
  max-height: 60px;
  overflow-y: auto;
}
.status-section p {
  border-left: 3px solid #007bff;
  transition: all 0.2s ease;
}
.status-section p:hover, .status-section p.status-section-active {
  background-color: #bab4f8 !important;
}
.action-buttons button {
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}
.action-buttons button:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.15);
}
.card {
  transition: all 0.2s ease;
}
.card:hover {
  box-shadow: 0 4px 12px rgba(0,0,0,0.1) !important;
}
.final-selection-card{
  background-color: rgba(40, 199, 111, 0.12);
}
.final-selection-card:hover, .final-selection-card-active{
  background-color: rgba(40, 199, 111, 0.32);
}
.rejected-card{
  background-color: rgb(234 84 85 / 22%)
}
.rejected-card:hover, .rejected-card-active{
  background-color: rgba(234, 84, 85, 0.4)
}
.shortlisted-card{
  background-color: rgb(188 199 40 / 12%);
}
.shortlisted-card:hover, .shortlisted-card-active{
  background-color: rgba(188, 199, 40, 0.27);
}
.applicant-card{
  background-color: rgba(115, 103, 240, 0.24);
}
.applicant-card:hover, .applicant-card-active{
  background-color: rgba(115, 103, 240, 0.49);
}
.selection-card:hover{
  background-color: rgba(115, 103, 240, 0.49);
}
.selection-status-card:hover, .selection-status-card-active{
  background-color: rgba(115, 103, 240, 0.49) !important;
}

@media (max-width: 768px) {
  .profile-photo {
    width: 60px;
    height: 60px;
  }

  .action-buttons {
    text-align: center;
  }

  .action-buttons button {
    margin-bottom: 0.5rem;
  }
}
</style>
